import { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

import CompanyPipeline from "./CompanyPipeline";
// import AddPipelineModal from "./AddPipelineModal";

const CompanyAddDeals = ({ show, handleClose }) => {
    const [showPipeline, setShowPipeline] = useState(false);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="deal-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Deals</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Row>
            <Col md={6}>
              <Form.Label>Deal Name *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Status *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <div className="d-flex justify-content-between">
                <Form.Label>Pipeline *</Form.Label>
<span onClick={() => setShowPipeline(true)} className="add-new">
  + Add New
</span>
              </div>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Currency *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Deal Value *</Form.Label>
              <Form.Control />
            </Col>

            <Col md={6}>
              <Form.Label>Period Value *</Form.Label>
              <Form.Control />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Period *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Contact *</Form.Label>
              <div className="tags-box">
                <span>Vaughan Lewis ✕</span>
                <input placeholder="Add new" />
              </div>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Project *</Form.Label>
            <div className="tags-box">
              <span>Office Management ✕</span>
              <span>Clinic Management ✕</span>
              <input placeholder="Add new" />
            </div>
          </Form.Group>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Due Date *</Form.Label>
              <div className="date-box">
                <Form.Control placeholder="dd/mm/yyyy" />
                <FiCalendar />
              </div>
            </Col>

            <Col md={6}>
              <Form.Label>Expected Closing Date *</Form.Label>
              <div className="date-box">
                <Form.Control placeholder="dd/mm/yyyy" />
                <FiCalendar />
              </div>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Assignee *</Form.Label>
            <div className="tags-box">
              <span>Vaughan Lewis ✕</span>
              <input placeholder="Add new" />
            </div>
          </Form.Group>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Tags *</Form.Label>
              <div className="tags-box">
                <span>Collab ✕</span>
                <input placeholder="Add new" />
              </div>
            </Col>

            <Col md={6}>
              <Form.Label>Followup Date *</Form.Label>
              <div className="date-box">
                <Form.Control placeholder="dd/mm/yyyy" />
                <FiCalendar />
              </div>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Source *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Priority *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Description *</Form.Label>
            <Form.Control as="textarea" rows={3} />
          </Form.Group>

          {/* FOOTER */}
          <div className="footer-actions">
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="btn-orange">Save</Button>
          </div>

        </Modal.Body>
        <CompanyPipeline
  show={showPipeline}
  handleClose={() => setShowPipeline(false)}
/>
      </Modal>

      {/* STYLES */}
      <style>{`
        .deal-modal .modal-content {
          border-radius: 10px;
        }

        .btn-orange {
          background:#ff6b2c;
          border:none;
          color:white;
        }

        .custom-select:focus {
          border-color:#ff6b2c;
          box-shadow:0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        option:checked {
          background:#ff6b2c;
          color:white;
        }

        .date-box {
          position:relative;
        }

        .date-box svg {
          position:absolute;
          right:10px;
          top:10px;
        }

        .tags-box {
          display:flex;
          flex-wrap:wrap;
          gap:6px;
          border:1px solid #ddd;
          padding:6px;
          border-radius:6px;
        }

        .tags-box span {
          background:#e5e7eb;
          padding:4px 8px;
          border-radius:6px;
          font-size:12px;
        }

        .tags-box input {
          border:none;
          outline:none;
          flex:1;
        }

        .add-new {
          color:#ff6b2c;
          font-size:13px;
          cursor:pointer;
        }

        .footer-actions {
          display:flex;
          justify-content:flex-end;
          gap:10px;
          margin-top:20px;
        }

        @media(max-width:768px){
          .footer-actions {
            flex-direction:column;
          }
        }
      `}</style>
    </>
  );
};

export default CompanyAddDeals;